import React, { useEffect, useState } from "react";
import DashboardPageHeader from "./DashboardPageHeader";
import LineChart from "../Charts/line";
import BarChart from "../Charts/bar";
import ApplicationStatics from "./ApplicationStatics";
import { getCurrentUser } from "../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAppTasks, getAllAppTasksByMonth, getDashboardReportByMonth,
  getDashboardReportByMonth1,
  getDashboardReportData, getDashboardRequests, getWfPhases, loadAllAppTasks, loadAllAppTasksByMonth,
  loadDashboardReportByMonth, loadDashboardReportByMonth1, loadDashboardReportData, loadWfPhases
} from "../app/store/dashboard";
import { setCurrentPageTitle, setCurrentRoute } from "../app/store/layoutUI";
import { getAllYears, getWfPhasesColor } from "../services/appService";

const Dashboard = () => {

  const [wfPhaseType, setWfPhaseType] = useState("WF Phases");
  const [workflowPhases, setWorkflowPhases] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const [applicationByMonth, setApplicationByMonth] = useState(null);
  const [applicationByMonth1, setApplicationByMonth1] = useState(null);
  const [allAppTasks, setAllAppTasks] = useState([]);
  const [allAppTasksByMonth, setAllAppTasksByMonth] = useState([]);
  const [onboardingLineYear, setOnboardingLineYear] = useState(new Date().getFullYear());
  const [onboardingBarYear, setOnboardingBarYear] = useState(new Date().getFullYear());
  const [onboardingWfBarYear, setOnboardingWfBarYear] = useState(new Date().getFullYear());
  const [onboardingWfYear, setOnboardingWfYear] = useState(new Date().getFullYear());


  const wfPhasesSelector = useSelector(getWfPhases);
  const dashboardReportDataSelector = useSelector(getDashboardReportData);
  const dashboardReportByMonthSelector = useSelector(getDashboardReportByMonth);
  const dashboardReportByMonth1Selector = useSelector(getDashboardReportByMonth1);
  const allAppTasksSelector = useSelector(getAllAppTasks);
  const allAppTasksByMonthSelector = useSelector(getAllAppTasksByMonth);
  const dashboardRequests = useSelector(getDashboardRequests);

  const isRefreshing = Object.values(dashboardRequests || {}).some((r) => r?.loading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  const years = getAllYears();

  const dashboardStyles = `
    /* ===========================================================================
       GLOBAL LAYOUT & RESET
    =========================================================================== */

    .modern-dashboard {
      background: radial-gradient(circle at top right, rgba(99, 102, 241, 0.03), transparent 600px),
                  radial-gradient(circle at bottom left, rgba(6, 182, 212, 0.02), transparent 500px),
                  #f6f8fa;
      font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      color: #1e293b;
      min-height: calc(100vh - 90px);
      padding: 4px 24px 36px;
    }

    .modern-dashboard * {
      font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    }

    .modern-dashboard i.fa,
    .modern-dashboard .fa {
      font-family: FontAwesome !important;
    }

    /* ===========================================================================
       KEYFRAME ANIMATIONS
    =========================================================================== */

    @keyframes heroGradientShift {
      0%, 100% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
    }

    @keyframes fadeSlideUp {
      0% { opacity: 0; transform: translateY(16px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    @keyframes fadeIn {
      0% { opacity: 0; }
      100% { opacity: 1; }
    }

    @keyframes shimmer {
      0% { background-position: -400px 0; }
      100% { background-position: 400px 0; }
    }

    @keyframes floatOrb {
      0%, 100% { transform: translate(0, 0) scale(1); filter: brightness(1); }
      33% { transform: translate(14px, -20px) scale(1.08); filter: brightness(1.1); }
      66% { transform: translate(-10px, 12px) scale(0.95); filter: brightness(0.95); }
    }

    @keyframes progressFill {
      0% { width: 0; }
    }

    @keyframes pulseGlow {
      0%, 100% { box-shadow: 0 0 0 0 rgba(99, 102, 241, 0.15); }
      50% { box-shadow: 0 0 0 8px rgba(99, 102, 241, 0.02); }
    }

    /* ===========================================================================
       HERO SECTION
    =========================================================================== */

    .modern-dashboard .dashboard-hero {
      animation: fadeSlideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
      background: linear-gradient(135deg, #ffffff 0%, #e2e8f0 100%);
      border: 1px solid rgba(15, 23, 42, 0.08);
      border-radius: 18px;
      color: #1e293b;
      margin-bottom: 24px;
      overflow: hidden;
      padding: 30px 32px 26px;
      position: relative;
      box-shadow:
        0 1px 3px rgba(15, 23, 42, 0.02),
        0 8px 24px rgba(15, 23, 42, 0.04),
        inset 0 1px 0 #ffffff;
    }

    .modern-dashboard .dashboard-hero-content {
      position: relative;
      z-index: 1;
    }

    .modern-dashboard .dashboard-hero-kicker {
      animation: fadeSlideUp 0.5s 0.1s cubic-bezier(0.16, 1, 0.3, 1) both;
      color: #64748b;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.08em;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    .modern-dashboard .dashboard-hero-title {
      animation: fadeSlideUp 0.5s 0.18s cubic-bezier(0.16, 1, 0.3, 1) both;
      color: #1e293b;
      font-size: 18px;
      font-weight: 500;
      letter-spacing: -0.02em;
      margin: 0;
    }

    .modern-dashboard .dashboard-hero-copy {
      animation: fadeSlideUp 0.5s 0.26s cubic-bezier(0.16, 1, 0.3, 1) both;
      color: #64748b;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.65;
      margin: 10px 0 0;
      max-width: 660px;
    }

    .modern-dashboard .dashboard-hero-right {
      animation: fadeSlideUp 0.5s 0.32s cubic-bezier(0.16, 1, 0.3, 1) both;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 12px;
    }

    .modern-dashboard .dashboard-hero-actions {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      justify-content: flex-end;
    }

    .modern-dashboard .dashboard-refresh-btn {
      align-items: center;
      background: rgba(255, 255, 255, 0.65);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border: 1px solid #cbd5e1;
      border-radius: 0;
      color: #1e293b;
      cursor: pointer;
      display: inline-flex;
      font-size: 14px;
      font-weight: 500;
      gap: 10px;
      outline: none;
      padding: 7px 14px;
      transition: all 0.3s ease;
      white-space: nowrap;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
    }

    .modern-dashboard .dashboard-refresh-btn:hover:not(:disabled) {
      background: #ffffff;
      border-color: #94a3b8;
      transform: translateY(-1px);
    }

    .modern-dashboard .dashboard-refresh-btn:disabled {
      cursor: not-allowed;
      opacity: 0.6;
      transform: none;
    }

    .modern-dashboard .dashboard-refresh-btn i {
      font-size: 14px;
      opacity: 0.85;
    }

    .modern-dashboard .dashboard-year-pill {
      align-items: center;
      background: rgba(255, 255, 255, 0.65);
      backdrop-filter: blur(16px);
      -webkit-backdrop-filter: blur(16px);
      border: 1px solid #cbd5e1;
      border-radius: 0;
      color: #1e293b;
      display: inline-flex;
      font-size: 14px;
      font-weight: 500;
      gap: 10px;
      padding: 7px 14px;
      transition: all 0.3s ease;
      white-space: nowrap;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
    }

    .modern-dashboard .dashboard-year-pill:hover {
      background: #ffffff;
      border-color: #94a3b8;
      transform: translateY(-1px);
    }

    .modern-dashboard .dashboard-year-pill i {
      font-size: 14px;
      opacity: 0.85;
    }

    .modern-dashboard .dashboard-hero-date {
      color: #64748b;
      font-size: 12px;
      font-weight: 400;
      text-align: right;
    }

    /* ===========================================================================
       CHART PANELS
    =========================================================================== */

    .modern-dashboard .dashboard-panel {
      animation: fadeSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) both;
      background: rgba(255, 255, 255, 0.65);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.65);
      border-radius: 16px;
      box-shadow:
        0 1px 3px rgba(15, 23, 42, 0.02),
        0 8px 24px rgba(15, 23, 42, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.7);
      height: 100%;
      overflow: hidden;
      transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .modern-dashboard .dashboard-panel:hover {
      border-color: rgba(99, 102, 241, 0.22);
      background: rgba(255, 255, 255, 0.78);
      box-shadow:
        0 2px 4px rgba(15, 23, 42, 0.03),
        0 16px 36px rgba(15, 23, 42, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.9);
      transform: translateY(-3px);
    }

    .modern-dashboard .dashboard-panel-header {
      align-items: center;
      border-bottom: 1px solid rgba(226, 232, 240, 0.6);
      display: flex;
      gap: 14px;
      justify-content: space-between;
      min-height: 72px;
      padding: 20px 22px;
    }

    .modern-dashboard .dashboard-panel-title-row {
      display: flex;
      align-items: center;
      gap: 10px;
      white-space: nowrap;
    }

    .modern-dashboard .dashboard-panel-dot {
      border-radius: 50%;
      display: inline-block;
      height: 8px;
      width: 8px;
      flex-shrink: 0;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.08);
    }

    .modern-dashboard .dashboard-panel-title {
      color: #1e293b;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.01em;
      margin: 0;
      white-space: nowrap;
    }

    .modern-dashboard .dashboard-panel-subtitle {
      color: #64748b;
      font-size: 12px;
      font-weight: 400;
      margin: 4px 0 0;
    }

    .modern-dashboard .dashboard-select {
      appearance: none;
      -webkit-appearance: none;
      background-color: rgba(248, 250, 252, 0.8);
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
      background-position: right 12px center;
      background-repeat: no-repeat;
      border: 1px solid #cbd5e1;
      border-radius: 0;
      color: #1e293b;
      cursor: pointer;
      font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
      font-size: 14px;
      font-weight: 500;
      width: 120px !important;
      height: auto !important;
      min-height: 32px !important;
      line-height: 1.2 !important;
      flex-shrink: 0;
      outline: none;
      padding: 7px 34px 7px 12px !important;
      transition: all 0.25s ease;
      box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
    }



    .modern-dashboard .dashboard-select:hover {
      border-color: #94a3b8;
      background-color: #ffffff;
      transform: translateY(-0.5px);
    }

    .modern-dashboard .dashboard-select:focus {
      border-color: #6366f1;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
      background-color: #ffffff;
    }

    .modern-dashboard .dashboard-chart-body {
      min-height: 335px;
      padding: 20px 22px;
    }

    .modern-dashboard .dashboard-chart-body .chart {
      height: 300px;
    }

    /* ===========================================================================
       ADMIN ACCORDION PANEL
    =========================================================================== */

    .modern-dashboard .dashboard-admin-panel {
      animation: fadeSlideUp 0.5s 0.1s cubic-bezier(0.16, 1, 0.3, 1) both;
      background: rgba(255, 255, 255, 0.55);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.65) !important;
      border-radius: 16px !important;
      box-shadow: 
        0 1px 3px rgba(15, 23, 42, 0.02),
        0 8px 24px rgba(15, 23, 42, 0.04),
        inset 0 1px 0 rgba(255, 255, 255, 0.7);
      margin-bottom: 24px;
      overflow: hidden;
      transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .modern-dashboard .dashboard-admin-panel:hover {
      border-color: rgba(99, 102, 241, 0.22) !important;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 
        0 2px 4px rgba(15, 23, 42, 0.03),
        0 12px 32px rgba(15, 23, 42, 0.07);
    }

    .modern-dashboard .dashboard-admin-toggle {
      align-items: center;
      background: rgba(248, 250, 252, 0.5) !important;
      border: 0;
      border-radius: 16px 16px 0 0 !important;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      padding: 20px 22px !important;
      transition: background 0.2s ease;
    }

    .modern-dashboard .dashboard-admin-toggle:hover {
      background: rgba(241, 245, 249, 0.7) !important;
    }

    .modern-dashboard .dashboard-admin-toggle h4 {
      color: #1e293b;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
    }

    .modern-dashboard .dashboard-admin-toggle .toggle-chevron {
      align-items: center;
      background: rgba(99, 102, 241, 0.06);
      border-radius: 8px;
      color: #6366f1;
      display: flex;
      height: 32px;
      justify-content: center;
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      width: 32px;
      border: 1px solid rgba(99, 102, 241, 0.1);
    }

    .modern-dashboard .dashboard-admin-toggle[aria-expanded="true"] .toggle-chevron {
      transform: rotate(180deg);
      background: #6366f1;
      color: #ffffff;
      border-color: #6366f1;
    }

    /* ===========================================================================
       WORKFLOW STATUS SECTION
    =========================================================================== */

    .modern-dashboard .workflow-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 0;
      padding: 0;
    }

    .modern-dashboard .workflow-item {
      background: rgba(255, 255, 255, 0.4);
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-left: 4px solid transparent;
      border-radius: 12px;
      list-style: none;
      padding: 14px 16px;
      transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
      box-shadow: 0 1px 2px rgba(0,0,0,0.02);
    }

    .modern-dashboard .workflow-item:hover {
      background: #ffffff;
      border-color: rgba(226, 232, 240, 0.9);
      box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
      transform: translateX(4px);
    }

    .modern-dashboard .workflow-item-head {
      align-items: center;
      display: flex;
      gap: 10px;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .modern-dashboard .workflow-name {
      align-items: center;
      color: #1e293b;
      display: flex;
      font-size: 14px;
      font-weight: 500;
      gap: 10px;
      min-width: 0;
    }

    .modern-dashboard .workflow-dot {
      border-radius: 999px;
      display: inline-block;
      flex: 0 0 auto;
      height: 10px;
      width: 10px;
      box-shadow: 0 0 0 3px rgba(0,0,0,0.03);
    }

    .modern-dashboard .workflow-count-badge {
      align-items: center;
      border-radius: 0;
      color: #ffffff;
      display: inline-flex;
      font-size: 12px;
      font-weight: 500;
      justify-content: center;
      min-width: 36px;
      padding: 4px 10px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }

    .modern-dashboard .workflow-bar-row {
      align-items: center;
      display: flex;
      gap: 12px;
    }

    .modern-dashboard .workflow-track {
      background: #e2e8f0;
      border-radius: 999px;
      flex: 1;
      height: 7px;
      overflow: hidden;
    }

    .modern-dashboard .workflow-fill {
      animation: progressFill 1s cubic-bezier(0.16, 1, 0.3, 1) both;
      border-radius: 999px;
      height: 100%;
      min-width: 4px;
    }

    .modern-dashboard .workflow-pct {
      color: #94a3b8;
      font-size: 12px;
      font-weight: 400;
      min-width: 36px;
      text-align: right;
    }

    .modern-dashboard .workflow-empty {
      align-items: center;
      color: #94a3b8;
      display: flex;
      flex-direction: column;
      gap: 8px;
      justify-content: center;
      padding: 48px 24px;
      text-align: center;
    }

    .modern-dashboard .workflow-empty i {
      font-size: 32px;
      opacity: 0.4;
    }

    .modern-dashboard .workflow-empty p {
      font-size: 14px;
      font-weight: 400;
      margin: 0;
    }

    /* ===========================================================================
       SKELETON / LOADING STATES
    =========================================================================== */

    .modern-dashboard .skeleton-block {
      animation: shimmer 1.6s infinite linear;
      background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 37%, #e2e8f0 63%);
      background-size: 800px 100%;
      border-radius: 10px;
    }

    .modern-dashboard .skeleton-cards {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
    }

    .modern-dashboard .skeleton-card {
      animation: shimmer 1.6s infinite linear;
      background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 37%, #e2e8f0 63%);
      background-size: 800px 100%;
      border-radius: 14px;
      flex: 1 1 220px;
      height: 140px;
      max-width: 320px;
    }

    .modern-dashboard .skeleton-chart {
      animation: shimmer 1.6s infinite linear;
      background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 37%, #e2e8f0 63%);
      background-size: 800px 100%;
      border-radius: 16px;
      height: 420px;
      width: 100%;
    }

    /* ===========================================================================
       SECTION DIVIDER
    =========================================================================== */

    .modern-dashboard .section-divider {
      background: linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.12), transparent);
      border: none;
      height: 1px;
      margin: 8px 0 20px;
    }


    /* Keep dashboard card containers square while preserving rounded icons and indicators. */
    .modern-dashboard .dashboard-hero,
    .modern-dashboard .dashboard-panel,
    .modern-dashboard .dashboard-admin-panel,
    .modern-dashboard .dashboard-admin-toggle,
    .modern-dashboard .workflow-item,
    .modern-dashboard .skeleton-card,
    .modern-dashboard .skeleton-chart {
      border-radius: 0 !important;
    }

    /* ===========================================================================
       RESPONSIVE
    =========================================================================== */

    @media (max-width: 767.98px) {
      .modern-dashboard {
        padding: 12px 12px 24px;
      }

      .modern-dashboard .dashboard-hero {
        border-radius: 12px;
        padding: 20px;
      }

      .modern-dashboard .dashboard-hero-title {
        font-size: 18px;
      }

      .modern-dashboard .dashboard-hero-copy {
        font-size: 14px;
      }

      .modern-dashboard .dashboard-panel {
        border-radius: 12px;
      }

      .modern-dashboard .dashboard-panel-header {
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
      }

      .modern-dashboard .dashboard-select {
        width: 100%;
      }

      .modern-dashboard .dashboard-hero-right {
        align-items: flex-start;
      }
    }

    @media (max-width: 1199.98px) {
      .modern-dashboard .dashboard-hero-title {
        font-size: 18px;
      }
    }
  `;

  useEffect(() => {
    dispatch(setCurrentPageTitle("Dashboard"));
    dispatch(setCurrentRoute([]));
  }, []);

  useEffect(() => {
    //dispatch(loadWfPhases(wfPhaseType));
    dispatch(loadDashboardReportData());

    setTimeout(() => {
      dispatch(loadDashboardReportByMonth(onboardingLineYear));
    }, 1000);

    setTimeout(() => {
      dispatch(loadDashboardReportByMonth1(onboardingBarYear));
    }, 2000);

    setTimeout(() => {
      dispatch(loadAllAppTasks(onboardingWfYear));
    }, 3000);

    setTimeout(() => {
      dispatch(loadAllAppTasksByMonth(onboardingWfBarYear));
    }, 4000);

  }, []);

  useEffect(() => {
    if (wfPhasesSelector.length > 0) {
      const filterWfPhases = wfPhasesSelector.
        filter(x => x.name !== "Enrollment"
          && x.name !== "Exit Survey"
          && x.name !== "Close"
          && x.name !== "Contract Document"
          && x.name !== "Invoice")
      setWorkflowPhases(filterWfPhases);
    }
  }, [wfPhasesSelector]);

  useEffect(() => {
    setDashboardData(dashboardReportDataSelector);
  }, [dashboardReportDataSelector]);

  useEffect(() => {
    setApplicationByMonth(dashboardReportByMonthSelector);
  }, [dashboardReportByMonthSelector]);

  useEffect(() => {
    setApplicationByMonth1(dashboardReportByMonth1Selector);
  }, [dashboardReportByMonth1Selector]);

  useEffect(() => {
    if (allAppTasksSelector) {
      const filterTasks = allAppTasksSelector.filter(x => x.wfPhase !== "Enrollment"
        && x.wfPhase !== "Exit Survey"
        && x.wfPhase !== "Close"
        && x.wfPhase !== "Contract Document"
        //&& x.wfPhase !== "Invoice"
        && x.wfPhase !== "Onboarding / Enrollment"
        && x.wfPhase !== "Review"
        && x.wfPhase !== "Application");
      setAllAppTasks(filterTasks);
    }

  }, [allAppTasksSelector]);

  useEffect(() => {
    if (allAppTasksByMonthSelector) {
      const filterTasks = allAppTasksByMonthSelector?.filter(x => x.type !== "Enrollment"
        && x.type !== "Exit Survey"
        && x.type !== "Close"
        && x.type !== "Contract Document"
        //&& x.wfPhase !== "Invoice"
        && x.type !== "Onboarding / Enrollment"
        && x.type !== "Review"
        && x.type !== "Application");
      setAllAppTasksByMonth(filterTasks);
    }
  }, [allAppTasksByMonthSelector]);

  const handleSelect = (e) => {
    //this.setState({ selectedKey: e });
  };

  const getWfPhasesItem = (name) => {
    const count = allAppTasks.filter(
      (x) => x.workflowPhase === name
    ).length;

    const color = getWfPhaseClassName(name);
    const total = allAppTasks.length || 1;
    const percentage = Math.round((count / total) * 100)

    return (
      <li className="list-group-item px-0">
        <div className="row align-items-center">
          <div className="col-auto">
            <span className={`avatar rounded-circle bg-${color}`}></span>
          </div>
          <div className="col">
            <h5>
              {name} ({count})
            </h5>
            <div className="progress progress-sm mb-0">
              <div
                className={`progress-bar bg-${color}`}
                role="progressbar"
                aria-valuenow={30}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{ width: `${percentage}%` }}
              />
            </div>
          </div>
        </div>
      </li>
    );
  }

  const getWfPhaseClassName = (name) => {
    // eslint-disable-next-line default-case
    switch (name) {
      case "Application":
        return "bg-primary";
      case "Onboarding":
        return "btn-wf2-default";
      case "Review":
        return "bg-yellow";
      case "Pending":
        return "bg-info";
      case "Approved":
        return "btn-wf3-default";
      case "Denied":
        return "bg-danger";
      case "Rejected":
        return "bg-danger";
      case "Withdrawn":
        return "bg-warning";
      case "Closed":
        return "bg-default";
      case "Compliance":
        return "btn-wf5-default";
      case "Time Log":
        return "btn-wf6-default";
      case "Invoice":
        return "btn-wf6-default";
      case "Underwriting Phase":
        return "lighter";
    }
  }

  // Mirrors the .btn-*-default rules in App.css, which is what getWfPhasesColor
  // resolves a phase to. fg follows the colour App.css pairs with each background.
  const wfPhasePalette = {
    "btn-primary": { bg: "#2944db", fg: "#ffffff" },
    "btn-info": { bg: "#11cdef", fg: "#000000" },
    "btn-warning": { bg: "#fb6340", fg: "#ffffff" },
    "btn-default": { bg: "#172b4d", fg: "#ffffff" },
    "btn-wf2-default": { bg: "#ffd600", fg: "#000000" },
    "btn-wf3-default": { bg: "#2dce898c", fg: "#000000" },
    "btn-wf4-default": { bg: "#f5365c", fg: "#ffffff" },
    "btn-wf5-default": { bg: "#e749a066", fg: "#000000" },
    "btn-wf6-default": { bg: "#c7a3ff", fg: "#000000" },
  };

  // Phase names the API sends that getWfPhasesColor has no case for.
  const wfPhaseAliases = {
    Rejected: "Denied",
    "Onboarding / Enrollment": "Onboarding",
  };

  const getWorkflowPalette = (name) => {
    const phase = wfPhaseAliases[name] || name;
    return wfPhasePalette[getWfPhasesColor(phase)] || { bg: "#94a3b8", fg: "#ffffff" };
  };

  const getWorkflowPercentage = (task) => {
    const baseline = allAppTasks.find((x) => x.wfPhase === "Onboarding")?.orderNumber;
    const maxCount = allAppTasks.reduce((max, item) => Math.max(max, Number(item.orderNumber) || 0), 1);
    const total = baseline || maxCount || 1;
    return task.orderNumber > 0 ? Math.min(100, Math.round((task.orderNumber / total) * 100)) : 0;
  }

  const renderYearSelect = (name, value, onChange) => (
    <select
      name={name}
      id={name}
      value={value}
      onChange={onChange}
      className="form-control form-control-sm dashboard-select"
    >
      <option value="">Year</option>
      {years.map((y) => (
        <option value={y.name} key={`${name}-${y.name}`}>
          {y.name}
        </option>
      ))}
    </select>
  );

  const chartPanelColors = {
    "Onboarding Trend": "#6366f1",
    "Onboarding Volume": "#10b981",
    "Workflow Status": "#8b5cf6",
    "Workflow Phase Volume": "#f59e0b",
  };

  const renderChartPanel = ({ title, subtitle, selectName, selectValue, onChange, children }) => (
    <div className="dashboard-panel">
      <div className="dashboard-panel-header">
        <div>
          <div className="dashboard-panel-title-row">
            <span
              className="dashboard-panel-dot"
              style={{ backgroundColor: chartPanelColors[title] || "#6366f1" }}
            />
            <h5 className="dashboard-panel-title">{title}</h5>
          </div>
          <p className="dashboard-panel-subtitle">{subtitle}</p>
        </div>
        {renderYearSelect(selectName, selectValue, onChange)}
      </div>
      <div className="dashboard-chart-body">
        {children}
      </div>
    </div>
  );

  // Refetches every panel at once, bypassing the api cache. The staggering used
  // on first mount is deliberate there; a manual refresh should not wait 4s.
  const handleRefresh = () => {
    dispatch(loadDashboardReportData(true));
    dispatch(loadDashboardReportByMonth(onboardingLineYear, true));
    dispatch(loadDashboardReportByMonth1(onboardingBarYear, true));
    dispatch(loadAllAppTasks(onboardingWfYear, true));
    dispatch(loadAllAppTasksByMonth(onboardingWfBarYear, true));
  };

  const handleChangeOnboardingLineYear = (e) => {
    setOnboardingLineYear(e.target.value);
    dispatch(loadDashboardReportByMonth(e.target.value));
  }

  const handleChangeOnboardingBarYear = (e) => {
    setOnboardingBarYear(e.target.value);
    dispatch(loadDashboardReportByMonth1(e.target.value));
  }
  const handleChangeOnboardingWfYear = (e) => {
    setOnboardingWfYear(e.target.value);
    dispatch(loadAllAppTasks(e.target.value));
  }

  const handleChangeOnboardingWfBarYear = (e) => {
    setOnboardingWfBarYear(e.target.value);
    dispatch(loadAllAppTasksByMonth(e.target.value));
  }

  const formatDate = () => {
    return new Date().toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const renderSkeletonCards = () => (
    <div className="skeleton-cards mb-3">
      {[...Array(4)].map((_, i) => (
        <div className="skeleton-card" key={`skel-${i}`} style={{ animationDelay: `${i * 0.15}s` }} />
      ))}
    </div>
  );

  const renderSkeletonChart = () => (
    <div className="skeleton-chart" />
  );

  return (
    <React.Fragment>
      <style>{dashboardStyles}</style>
      <div className="col-md-12 modern-dashboard">
        <h2 className="visually-hidden">{"Application"}</h2>
        <h3 className="visually-hidden">{"Application"}</h3>

        {/* ─── HERO SECTION ─── */}
        <div className="dashboard-hero">
          <div className="dashboard-hero-content">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <h1 className="dashboard-hero-title">Dashboard</h1>
                <p className="dashboard-hero-copy">
                  A live view of onboarding, staffing engagement, users, and workflow health across the workspace.
                </p>
              </div>
              <div className="col-lg-4 mt-3 mt-lg-0">
                <div className="dashboard-hero-right">
                  <div className="dashboard-hero-actions">
                    <button
                      type="button"
                      className="dashboard-refresh-btn"
                      onClick={handleRefresh}
                      disabled={isRefreshing}
                      title="Reload dashboard data"
                    >
                      <i className={`fa fa-refresh${isRefreshing ? " fa-spin" : ""}`} />
                      {isRefreshing ? "Refreshing…" : "Refresh"}
                    </button>
                    <span className="dashboard-year-pill">
                      <i className="fa fa-calendar-check-o" />
                      Reporting year {new Date().getFullYear()}
                    </span>
                  </div>
                  <span className="dashboard-hero-date">
                    {formatDate()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ─── METRIC CARDS ─── */}
        {dashboardData ? (
          <DashboardPageHeader
            dashboardData={dashboardData}
          ></DashboardPageHeader>
        ) : (
          renderSkeletonCards()
        )}

        <hr className="section-divider" />

        {/* ─── CHARTS ROW 1 ─── */}
        <div className="row mb-4 mt-1">
          <div className="col-xl-7 mb-4 mb-xl-0">
            {applicationByMonth ? renderChartPanel({
              title: "Onboarding Trend",
              subtitle: "Subcontractor, recruiter, and candidate flow",
              selectName: "onboardingLineYear",
              selectValue: onboardingLineYear,
              onChange: handleChangeOnboardingLineYear,
              children: <LineChart
                graphData={applicationByMonth}
                label={"Candidates"}
              ></LineChart>
            }) : renderSkeletonChart()}
          </div>
          <div className="col-xl-5">
            {applicationByMonth1 ? renderChartPanel({
              title: "Onboarding Volume",
              subtitle: "Monthly distribution",
              selectName: "onboardingBarYear",
              selectValue: onboardingBarYear,
              onChange: handleChangeOnboardingBarYear,
              children: <BarChart
                graphData={applicationByMonth1}
                label={"Candidates"}
              ></BarChart>
            }) : renderSkeletonChart()}
          </div>
        </div>

        {/* ─── ADMIN STATISTICS (Statically Loaded) ─── */}
        {currentUser.type === "admin" && (
          <div className="row mb-4">
            <div className="col-md-12">
              <div className="dashboard-panel">
                <div className="dashboard-panel-header">
                  <div>
                    <div className="dashboard-panel-title-row">
                      <span
                        className="dashboard-panel-dot"
                        style={{ backgroundColor: "#3b82f6" }}
                      />
                      <h5 className="dashboard-panel-title">
                        Real-time Application Statistics (Run-Time)
                      </h5>
                    </div>
                    <p className="dashboard-panel-subtitle">
                      Live configuration objects, active workflows, and system asset metrics
                    </p>
                  </div>
                </div>
                <div className="dashboard-chart-body" style={{ minHeight: "auto", padding: "24px 22px" }}>
                  <ApplicationStatics />
                </div>
              </div>
            </div>
          </div>
        )}


        <hr className="section-divider" />

        {/* ─── CHARTS ROW 2 — WORKFLOW ─── */}
        <div className="row">
          <div className="col-xl-5 mb-4 mb-xl-0">
            <div className="dashboard-panel">
              <div className="dashboard-panel-header">
                <div>
                  <div className="dashboard-panel-title-row">
                    <span
                      className="dashboard-panel-dot"
                      style={{ backgroundColor: "#8b5cf6" }}
                    />
                    <h5 className="dashboard-panel-title">
                      Workflow Status
                    </h5>
                  </div>
                  <p className="dashboard-panel-subtitle">
                    Current onboarding and engagement phases
                  </p>
                </div>
                {renderYearSelect("onboardingWfYear", onboardingWfYear, handleChangeOnboardingWfYear)}
              </div>
              <div className="card-body">
                {allAppTasks.length > 0 ? (
                  <ul className="workflow-list">
                    {allAppTasks.map((p, index) => {
                      const pct = getWorkflowPercentage(p);
                      const { bg: color, fg: countColor } = getWorkflowPalette(p.wfPhase);
                      return (
                        <li
                          className="workflow-item"
                          key={p.wfPhase}
                          style={{
                            borderLeftColor: color,
                            animationDelay: `${index * 0.06}s`,
                            animation: `fadeSlideUp 0.4s ${index * 0.06}s cubic-bezier(0.23, 1, 0.32, 1) both`
                          }}
                        >
                          <div className="workflow-item-head">
                            <div className="workflow-name">
                              <span
                                className="workflow-dot"
                                style={{ backgroundColor: color }}
                              />
                              <span>{p.wfPhase}</span>
                            </div>
                            <span
                              className="workflow-count-badge"
                              style={{ backgroundColor: color, color: countColor }}
                            >
                              {p.orderNumber}
                            </span>
                          </div>
                          <div className="workflow-bar-row">
                            <div className="workflow-track">
                              <div
                                className="workflow-fill"
                                role="progressbar"
                                aria-valuemin={0}
                                aria-valuemax={100}
                                aria-valuenow={pct}
                                style={{
                                  width: `${pct}%`,
                                  backgroundColor: color,
                                  animationDelay: `${0.3 + index * 0.08}s`
                                }}
                              />
                            </div>
                            <span className="workflow-pct">{pct}%</span>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="workflow-empty">
                    <i className="fa fa-pie-chart" />
                    <p>No workflow data available for the selected year</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-7">
            {allAppTasksByMonth ? renderChartPanel({
              title: "Workflow Phase Volume",
              subtitle: "Monthly phase activity",
              selectName: "onboardingWfBarYear",
              selectValue: onboardingWfBarYear,
              onChange: handleChangeOnboardingWfBarYear,
              children: <BarChart
                graphData={allAppTasksByMonth}
                label={"Workflow Phases"}
                colorFor={(phase) => getWorkflowPalette(phase).bg}
              ></BarChart>
            }) : renderSkeletonChart()}
          </div>
        </div>


      </div>

    </React.Fragment>
  );
}

export default Dashboard;
